import React, { useState } from 'react'
import Avatar from '../../Components/Avatar'
import ProfileModals from '../../Components/ProfileModals'
import { capitalize } from '../../utils/formatters'

export default function Dashboard({ user, memberships }) {
  const [showProfile, setShowProfile] = useState(false)

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Welcome back</h1>
              <p className="text-sm text-gray-600">{user.name || user.email}</p>
            </div>
            <div className="flex items-center gap-4">
              <Avatar
                initials={user.initials}
                onClick={() => setShowProfile(true)}
              />
            </div>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Account memberships */}
        <div className="bg-white shadow rounded-lg">
          <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
            <h2 className="text-lg font-medium text-gray-900">Your Memberships</h2>
            <p className="mt-1 text-sm text-gray-500">
              Golf clubs you're a member of
            </p>
          </div>

          {memberships.length === 0 ? (
            <div className="px-4 py-12 text-center">
              <p className="text-gray-500">You're not a member of any clubs yet.</p>
            </div>
          ) : (
            <ul className="divide-y divide-gray-200">
              {memberships.map((membership) => (
                <li key={membership.id} className="px-4 py-4 sm:px-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-sm font-medium text-gray-900">
                        {membership.account.name}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {capitalize(membership.role)}
                      </p>
                    </div>
                    <div className="flex items-center gap-3">
                      <a
                        href={`/${membership.account.slug}/order`}
                        className="text-sm text-sky-600 hover:text-sky-500"
                      >
                        Order Food
                      </a>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </main>

      <ProfileModals
        user={user}
        basePath="/members"
        isOpen={showProfile}
        onClose={() => setShowProfile(false)}
      />
    </div>
  )
}
